export default __webpack_public_path__ + "static/media/mpinEasy.75448cd2.png";